import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E02 — ÉCLAT. Le professeur de tir visé.
 *
 *  Une seule balle, visée sur le joueur, toutes les 1,6 s. C'est l'ennemi qui
 *  enseigne la mécanique la plus importante du genre : le joueur découvre en
 *  bougeant qu'il peut MANIPULER un tir, et non seulement l'esquiver. À partir
 *  de là, il ne subit plus les patterns — il les pilote.
 *
 *  Toujours introduit SEUL, en première vague. Une leçon donnée au milieu du
 *  bruit n'est pas une leçon. */
export default defineEnemy({
  id: 'eclat',
  rank: Rank.Popcorn,
  hp: 45,
  visualRadius: 20,
  score: 90,
  telegraph: 0.7,
  drops: 1,
  motion: { kind: Motion.Sine, speed: 230, amplitude: 120, frequency: 2.2 },
  emitter: {
    pattern: Pattern.Aimed,
    every: 1.6,
    count: 1,
    speed: 450,
    firstDelay: 1.6,
    family: Fam.EnemyRed,
  },
});

